/* eslint-disable @reatom/unit-naming-rule */
import { useAtom } from '@reatom/npm-react'
import { useEffect } from 'react'
import { Outlet, useParams } from 'react-router'
import styled from 'styled-components'

import { delugeIdAtom } from '@root/entities/auth'
import { selectedNetworkAtom } from '@root/entities/network'
import { profileStateAtom, reatomUserProfile } from '@root/entities/profile'
import { otherUserDelugeIdAtom } from '@root/entities/profile/atoms'
import { layoutHeightCss } from '@root/shared/ui-kit/utils/page-layout'

import { BoardSidebar } from './common/board-sidebar'

import type { DelugeId } from '@root/entities/user-short/model'

type Props = {
  delugeId: DelugeId | undefined
}
const ProfilePage_: React.FC<Props> = ({ delugeId }) => {
  const [currentDelugeId] = useAtom(delugeIdAtom)
  const isCurrentUser = !delugeId || delugeId === currentDelugeId
  const [stateAtom] = useAtom(
    (ctx) => {
      if (isCurrentUser) {
        return profileStateAtom
      }
      const network = ctx.spy(selectedNetworkAtom)
      const model = reatomUserProfile({ delugeId, network })
      return model
    },
    [delugeId, isCurrentUser],
  )
  const [state] = useAtom(stateAtom)

  // TODO: Get rid of this
  const [_otherUserDelugeId, setOtherUserDelugeIdAtom] = useAtom(
    otherUserDelugeIdAtom,
  )
  useEffect(() => {
    setOtherUserDelugeIdAtom(delugeId)
    return () => {
      setOtherUserDelugeIdAtom(undefined)
    }
  }, [delugeId, setOtherUserDelugeIdAtom])

  const resolvedDelugeId = delugeId ?? currentDelugeId
  if (!resolvedDelugeId) {
    return undefined
  }

  return (
    <Root>
      <BoardSidebar delugeId={resolvedDelugeId} state={state} />
      <BoardMain>
        <Outlet />
      </BoardMain>
    </Root>
  )
}

export const ProfilePage: React.FC = () => {
  const delugeId = useParams<{ delugeId?: DelugeId }>().delugeId
  return <ProfilePage_ delugeId={delugeId} key={delugeId} />
}

const Root = styled.div`
  ${layoutHeightCss}

  position: relative;
  display: grid;
  gap: 10px;
  padding: 10px;
  grid-template-columns: 370px minmax(0, 1fr);
`

const BoardMain = styled.div`
  min-height: 0;
  min-width: 0;
  overflow: auto;
`
